<template>
  <div class="a">
    <el-form
      ref="addForm"
      :model="addForm"
      label-width="100px"
      :disabled='disabled'
      style="margin-top:50px;margin-left:20px;"
    >
      <el-form-item style="width:90%" label="兴趣爱好:" prop="hobby">
        <!-- <el-checkbox-group v-model="addForm.hobby">
          <el-checkbox label="民族舞" name="hobby"></el-checkbox>
          <el-checkbox label="街舞" name="hobby"></el-checkbox>
          <el-checkbox label="油画" name="hobby"></el-checkbox>
          <el-checkbox label="豫剧" name="hobby"></el-checkbox>
          <el-checkbox label="秦腔" name="hobby"></el-checkbox>
          <el-checkbox label="评剧" name="hobby"></el-checkbox>
          <el-checkbox label="武术" name="hobby"></el-checkbox>
          <el-checkbox label="螳螂拳" name="hobby"></el-checkbox>
          <el-checkbox label="养生操" name="hobby"></el-checkbox>
          <el-checkbox label="气功" name="hobby"></el-checkbox>
          <el-checkbox label="养宠物" name="hobby"></el-checkbox>
          <el-checkbox label="时装表演" name="hobby"></el-checkbox>
          <el-checkbox label="登山" name="hobby"></el-checkbox>
          <el-checkbox label="竞走" name="hobby"></el-checkbox>
          <el-checkbox label="篮球" name="hobby"></el-checkbox>
          <el-checkbox label="网球" name="hobby"></el-checkbox>
          <el-checkbox label="保龄球" name="hobby"></el-checkbox>
          <el-checkbox label="跳棋" name="hobby"></el-checkbox>
          <el-checkbox label="五子棋" name="hobby"></el-checkbox>
          <el-checkbox label="钢琴" name="hobby"></el-checkbox>
          <el-checkbox label="口琴" name="hobby"></el-checkbox>
          <el-checkbox label="笛子" name="hobby"></el-checkbox>
          <el-checkbox label="古筝" name="hobby"></el-checkbox>
          <el-checkbox label="琵琶" name="hobby"></el-checkbox>
          <el-checkbox label="子架鼓" name="hobby"></el-checkbox>
          <el-checkbox label="收藏" name="hobby"></el-checkbox>
          <el-checkbox label="晨练" name="hobby"></el-checkbox>
          <el-checkbox label="国标舞" name="hobby"></el-checkbox>
          <el-checkbox label="交谊舞" name="hobby"></el-checkbox>
          <el-checkbox label="京剧" name="hobby"></el-checkbox>
          <el-checkbox label="粤剧" name="hobby"></el-checkbox>
          <el-checkbox label="梆子" name="hobby"></el-checkbox>
          <el-checkbox label="昆曲" name="hobby"></el-checkbox>
          <el-checkbox label="太极" name="hobby"></el-checkbox>
          <el-checkbox label="少林拳" name="hobby"></el-checkbox>
          <el-checkbox label="八段锦" name="hobby"></el-checkbox>
          <el-checkbox label="六字诀" name="hobby"></el-checkbox>
          <el-checkbox label="种花" name="hobby"></el-checkbox>
          <el-checkbox label="钓鱼" name="hobby"></el-checkbox>
          <el-checkbox label="骑车" name="hobby"></el-checkbox>
          <el-checkbox label="羽毛球" name="hobby"></el-checkbox>
          <el-checkbox label="足球" name="hobby"></el-checkbox>
          <el-checkbox label="桌球" name="hobby"></el-checkbox>
          <el-checkbox label="高尔夫球" name="hobby"></el-checkbox>
          <el-checkbox label="军旗" name="hobby"></el-checkbox>
          <el-checkbox label="扑克牌" name="hobby"></el-checkbox>
          <el-checkbox label="小提琴" name="hobby"></el-checkbox>
          <el-checkbox label="手风琴" name="hobby"></el-checkbox>
          <el-checkbox label="腰鼓" name="hobby"></el-checkbox>
          <el-checkbox label="萨克斯" name="hobby"></el-checkbox>
          <el-checkbox label="唢呐" name="hobby"></el-checkbox>
          <el-checkbox label="抖空竹" name="hobby"></el-checkbox>
          <el-checkbox label="集邮" name="hobby"></el-checkbox>
          <el-checkbox label="晚练" name="hobby"></el-checkbox>
          <el-checkbox label="广场舞" name="hobby"></el-checkbox>
          <el-checkbox label="现代舞" name="hobby"></el-checkbox>
          <el-checkbox label="国画" name="hobby"></el-checkbox>
          <el-checkbox label="庐剧" name="hobby"></el-checkbox>
          <el-checkbox label="黄梅戏" name="hobby"></el-checkbox>
          <el-checkbox label="川剧" name="hobby"></el-checkbox>
          <el-checkbox label="剪纸" name="hobby"></el-checkbox>
          <el-checkbox label="八极拳" name="hobby"></el-checkbox>
          <el-checkbox label="咏春拳" name="hobby"></el-checkbox>
          <el-checkbox label="五禽戏" name="hobby"></el-checkbox>
          <el-checkbox label="养鱼" name="hobby"></el-checkbox>
          <el-checkbox label="烹饪" name="hobby"></el-checkbox>
          <el-checkbox label="冬泳" name="hobby"></el-checkbox>
          <el-checkbox label="乒乓球" name="hobby"></el-checkbox>
          <el-checkbox label="排球" name="hobby"></el-checkbox>
          <el-checkbox label="门球" name="hobby"></el-checkbox>
          <el-checkbox label="围棋" name="hobby"></el-checkbox>
          <el-checkbox label="象棋" name="hobby"></el-checkbox>
          <el-checkbox label="麻将" name="hobby"></el-checkbox>
          <el-checkbox label="大提琴" name="hobby"></el-checkbox>
          <el-checkbox label="二胡" name="hobby"></el-checkbox>
          <el-checkbox label="吉他" name="hobby"></el-checkbox>
          <el-checkbox label="葫芦丝" name="hobby"></el-checkbox>
          <el-checkbox label="箫" name="hobby"></el-checkbox>
          <el-checkbox label="魔术" name="hobby"></el-checkbox>
          <el-checkbox label="古玩" name="hobby"></el-checkbox>
          <el-checkbox label="跑步" name="hobby"></el-checkbox>
        </el-checkbox-group> -->
        <el-checkbox-group v-model="addForm.hobby">
            <el-checkbox v-for="(item,i) in hobbyListArray" :key="i" :label="item" name="hobby"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="其他：" prop="otherHobby">
        <el-input style="width:70%" v-model="addForm.otherHobby"></el-input>
      </el-form-item>
      <el-form-item v-show="!disabled">
        <div style="width:100%;justify-content:center;display:flex;">
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {
      loading: false,
      disabled: false,
      addForm: {
        timeStr: timeStr,
        staffCode: getStaffCode(),
        sign: "",
        userCode: "",
        elderlyCode: "",
        hobby: [],
        otherHobby: "",
      },
      hobbyListArray:["民族舞","街舞","养宠物","气功","油画","时装表演","五子棋","国标舞","六字诀","扑克牌","晚练","咏春拳","象棋","五禽戏","广场舞","麻将","小提琴","种花","交谊舞","钢琴","口琴","京剧","钓鱼","手风琴","现代舞","养鱼","大提琴","二胡","烹饪","国画","腰鼓","骑车","粤剧","笛子","登山","豫剧","秦腔","竞走","古筝","梆子","羽毛球","萨克斯","庐剧","冬泳","吉他","葫芦丝","乒乓球","黄梅戏","唢呐","足球","昆曲","琵琶","篮球","评剧","武术","网球","子架鼓","太极","桌球","抖空竹","川剧","排球","箫","魔术","门球","剪纸","集邮","高尔夫球","少林拳","收藏","保龄球","螳螂拳","养生操","跳棋","晨练","八段锦","军旗","八极拳","围棋","古玩","跑步"]
    };
  },
  created() {},
  components: {},
  watch: {
    //监听全局变量
    "$store.state.tableHeight": function () {},
  },
  methods: {
    init(flag, row,disabled) {
      if(disabled)this.disabled=disabled
      this.$refs.addForm.resetFields();
      this.addForm.elderlyCode = row.elderlyCode;
      this.addForm.userCode = row.userCode;
      if (flag) {
        this.getElderlyHobby();
      }
    },
    onSubmit() {
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }
      this.addForm.sign = hex_md5(
        "timeStr=" + timeStr + "&key=" + this.$signKey
      );
      this.$axios({
        method: "post",
        url: this.$shopUrl + "EHobby/Add",
        data: this.addForm,
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      });
    },

    getElderlyHobby() {
      this.addForm.sign = hex_md5(
        "timeStr=" + timeStr + "&key=" + this.$signKey
      );
      this.$axios({
        method: "post",
        url: this.$shopUrl + "EHobby/GetByElderlyCode",
        data: this.addForm,
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.addForm.otherHobby = response.data.data.otherHobby;
            this.addForm.hobby = response.data.data.hobby.split(",");
            if(this.disabled){
              this.hobbyListArray=this.addForm.hobby
            }
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style  lang="scss" scoped>
.a {
  /deep/ .el-checkbox__label {
    font-size: 17px;
  }
  /deep/ .el-form-item__label {
    font-size: 20px;
  }
  
}
</style>
